import React from 'react';
import { useStyletron } from 'baseui';

const KeyValueEnteringGuide = () => {
	const [css] = useStyletron();
	const info = css({
		paddingTop: '5px',
		paddingBottom: '5px'
	});
	const infoContainer = css({
		paddingLeft: '20px'
	});
	const container = css({
		padding: '10px'
	});
	return (
		<div className={container}>
			<h3> Key Value Entering Guide</h3>
			<ul className={infoContainer}>
				<li className={info}>{`The Strings must be inside double quotes.Ex "Some Value" `}</li>
				<li className={info}>
					{`The arrays ,must be entered like this -> [1,2,"abc"]. Strings must be in quotes, numbers must be without quotes. `}
				</li>
				<li className={info}>{`JSON objects must be entered like this {"a":1, "b": "some value"}`}</li>
				<li className={info}>Boolean values must be simple true or false</li>
				<li className={info}>
					<p>The Numbers should be like 1,23, 567, etc.</p>
					<p>Too big numbers or too small numbers should be stored using strings and not numbers</p>
				</li>
				<li className={info}>
					For Null values, just select Null from the value type. /n The text input area gets disabled while selecting null
				</li>
			</ul>
		</div>
	);
};

export default KeyValueEnteringGuide;
